import React from 'react';
import { ParameterType, Type } from '../apiref/apireftypes';

export function createTrainUsage() : ParameterType
{
    const desc = (<>
        <h3>Train Usage</h3>
        <p>Usage statistics for the training operation, including token counts and training configuration details.</p>
        </>);

    return {
        id          : "TrainUsage",
        name        : "TrainUsage",
        description : desc,
        type        : Type.Object,
        parameters  : [
            {
                "name"        : "input_tokens",
                "type"        : "number",
                "description" : <p>The number of tokens in the input messages.</p>,
                "optional"    : false
            },
            {
                "name"        : "output_tokens",
                "type"        : "number",
                "description" : <p>The number of tokens in the output responses.</p>,
                "optional"    : false
            },
            {
                "name"        : "num_samples",
                "type"        : "number",
                "description" : <p>The number of response samples provided in the training data.</p>,
                "optional"    : false
            },
            {
                "name"        : "steps",
                "type"        : "number",
                "description" : <p>The number of training steps that were executed.</p>,
                "optional"    : false
            },
            {
                "name"        : "training_tokens",
                "type"        : "number",
                "description" : <>
                                <p>The total number of tokens processed during training, calculated as 
                                <pre><code>(input_tokens * num_samples + output_tokens) * steps</code></pre>.</p>
                                <p>This is the only metric used for calculating charges in training operations.</p>
                                </>,
                "optional"    : false
            },
            {
                "name"        : "duration_ms",
                "type"        : "number",
                "description" : <p>The duration of the training operation itself in milliseconds, excluding setup time.</p>,
                "optional"    : false
            }
        ]
    };
}

